import locale from "@/helpers/locale";
import moment from "moment";
import { toThousands } from "@/utils/common.js";

const _YEN = "¥ ";

/**
 *
 *
 *
 * For DailyClosing
 *
 *
 */
export const createDailyClosingColumn = () => {
  return [
    {
      label: locale("dailyClosing.th.cinemaName"),
      prop: "cinemaName",
      apiProp: "cinemaName",
      sort: false,
      width: 260,
      align: "left",
    },
    {
      label: locale("dailyClosing.th.dayCloseDate"),
      prop: "dayCloseDate",
      apiProp: "dayCloseDate",
      sort: "custom",
      width: 150,
    },
    {
      label: locale("dailyClosing.th.operationName"),
      prop: "operationName",
      apiProp: "operationName",
      sort: false,
      width: 200,
      align: "left",
    },
    {
      label: locale("dailyClosing.th.type"),
      prop: "type",
      apiProp: "type",
      sort: false,
      width: 100,
    },
    {
      label: locale("dailyClosing.th.dueDate"),
      prop: "dueDate",
      apiProp: "dueDate",
      sort: "custom",
      width: 150,
    },
  ];
};

export const formatData = originalArr => {
  let newArr = [];
  let notApprove = 0;

  originalArr.map(item => {
    let obj = {};

    obj.id = item.id;
    obj.cinemaName = item.cinemaName;
    obj.dayCloseDate = `${moment(item.dayCloseDate).format("YYYY/MM/DD")}`;
    obj.operationName = item.operationName;
    obj.dueDate = `${moment(item.dueDate).format("YYYY/MM/DD HH:mm")}`;
    obj.approve = item.approve;

    if (!obj.approve) {
      notApprove += 1;
    }
    newArr.push(obj);
  });

  return {
    notApprove: notApprove,
    tableData: newArr
  };
};

export const formatTargetData = originalArr => {
  let newArr = [];

  originalArr.map(item => {
    let obj = {};

    obj.id = item.id;
    obj.deviceName = item.deviceName;
    obj.deviceType = item.deviceType;
    obj.closeUserName = item.closeUserName;
    obj.operatingTime = `${moment(item.openTime).format("YYYY/MM/DD HH:mm")} - ${moment(item.closeTime).format("YYYY/MM/DD HH:mm")}`;

    newArr.push(obj);
  });

  return {
    tableData: newArr,
  };
};

/**
 *
 *
 *
 * For CreateDailyClosingDialog - AccountsReceivableCashCollectionRegistrationTable
 *
 *
 */
export const formatAccountsReceivableCashCollectionData = originAlArr => {
  let newArr = JSON.parse(JSON.stringify(originAlArr));

  newArr.map(obj => {
    obj.billingDeadline = obj.billingDeadline === "" ? "-" : obj.billingDeadline;
    obj.plannedDepositDate = obj.plannedDepositDate === "" ? "-" : obj.plannedDepositDate;
    obj.accountReceivableBalance = obj.accountReceivableBalance === 0 ? "-" : obj.accountReceivableBalance;
    obj.cashCollectionAmount = obj.cashCollectionAmount === 0 ? "" : obj.cashCollectionAmount; //no "-" when no data
    obj.accountReceivableBalanceAfterCollection = obj.accountReceivableBalanceAfterCollection === 0 ? "-" : obj.accountReceivableBalanceAfterCollection;

    return obj;
  });

  return newArr;
};

export const createAccountsReceivableCashCollectionNullTr = () => ({
  billingSubject: "",
  billingDetail: "",
  billingDeadline: "",
  plannedDepositDate: "",
  accountReceivableBalance: 0,
  cashCollectionAmount: 0,
  accountReceivableBalanceAfterCollection: 0
});


export const createAccountsReceivableCashCollectionData = originAlArr => {
  let newArr = [];
  let lastTr = {
    accountReceivableBalance: "合計額",
    cashCollectionAmount: 0,
    //accountReceivableBalance: locale("dailyClosing.createDialog.accountsReceivableCashCollectionRegistrationTable.total"),
  }; //total row

  if (originAlArr.length > 0) {
    originAlArr.map(item => {
      let { cashCollectionAmount } = item;
      newArr.push({
        billingDetail: item.requestDetailsId,
        billingDetailName: item.requestDetails,
        billingSubject: item.requestId,
        billingSubjectName: item.requestName,
        billingDeadline: item.requestDeadDate,
        plannedDepositDate: item.depositDate,
        accountReceivableBalance: item.actualAmountResidual,
        cashCollectionAmount: item.cashRecoveryAmount,
        accountReceivableBalanceAfterCollection: item.actualAmountResidualAfter
      });
      lastTr.cashCollectionAmount += cashCollectionAmount;
    });
    // lastTr.cashCollectionAmount = lastTr.cashCollectionAmount ? lastTr.cashCollectionAmount : 0;
  } else {
    newArr.push(createAccountsReceivableCashCollectionNullTr());
  }

  newArr.push(lastTr);

  return newArr;
};


export const reverseAccountReceivableCashCollectionData = originAlArr => {
  let newArr = JSON.parse(JSON.stringify(originAlArr));

  newArr.map(obj => {


    if (typeof(obj.accountReceivableBalance) == "string") {
      obj.accountReceivableBalance = parseFloat(obj.accountReceivableBalance.replace(/[^\d.-]/g, "")) || 0;
    }

    if (typeof(obj.cashCollectionAmount) == "string") {
      obj.cashCollectionAmount = parseFloat(obj.cashCollectionAmount.replace(/[^\d.-]/g, "")) || 0;
    }

    if (typeof(obj.accountReceivableBalanceAfterCollection) == "string") {
      obj.accountReceivableBalanceAfterCollection = parseFloat(obj.accountReceivableBalanceAfterCollection.replace(/[^\d.-]/g, "")) || 0;
    }

    if(typeof(obj.billingDeadline) === "string") {
      obj.billingDeadline = parseFloat(obj.billingDeadline.replace(/[^\d.-]/g, "")) || 0;
    }
    if(typeof(obj.plannedDepositDate) === "string") {
      obj.plannedDepositDate = parseFloat(obj.plannedDepositDate.replace(/[^\d.-]/g, "")) || 0;
    }

    return obj;
  });

  return newArr;
};


/**
 *
 *
 *
 * For CreateDailyClosingDialog - AccountsPayableCashPaymentRegistrationTable
 *
 *
 */
export const formatAccountsPayableCashCollectionData = originAlArr => {
  let newArr = JSON.parse(JSON.stringify(originAlArr));

  newArr.map(obj => {
    obj.billingDeadline = obj.billingDeadline === "" ? "-" : obj.billingDeadline;
    obj.plannedDepositDate = obj.plannedDepositDate === "" ? "-" : obj.plannedDepositDate;
    obj.accountPayableBalance = obj.accountPayableBalance === 0 ? "-" : obj.accountPayableBalance;
    obj.cashPaymentAmount = obj.cashPaymentAmount === 0 ? "" : obj.cashPaymentAmount; //no "-" when no data
    obj.accountPayableBalanceAfterPayment = obj.accountPayableBalanceAfterPayment === 0 ? "-" : obj.accountPayableBalanceAfterPayment;

    return obj;
  });

  return newArr;
};

export const createAccountsPayableCashCollectionNullTr = () => ({
  billingSubject: "",
  billingDetail: "",
  billingDeadline: "",
  paymentDueDate: "",
  accountPayableBalance: 0,
  cashPaymentAmount: 0,
  accountPayableBalanceAfterPayment: 0
});


export const createAccountsPayableCashCollectionData = originAlArr => {
  let newArr = [];
  let lastTr = {
    accountPayableBalance: "合計額",
    cashPaymentAmount: 0
    //accountReceivableBalance: locale("dailyClosing.createDialog.accountsReceivableCashCollectionRegistrationTable.total"),
  }; //total row

  if (originAlArr.length > 0) {
    originAlArr.map(item => {
      let { cashPaymentAmount } = item;
      newArr.push({
        accountPayableBalanceAfterPayment: item.accountsPayableAfter,
        accountPayableBalance: item.actualAmountResidual,
        cashPaymentAmount: item.cashDisbursementAmount,
        paymentDueDate: item.payDate,
        billingDeadline: item.requestDeadDate,
        billingDetail: item.requestDetails,
        billingDetailName: item.requestDetailsId,
        billingSubject: item.requestId,
        billingSubjectName: item.requestName
      });
      lastTr.cashPaymentAmount += cashPaymentAmount;
    });
    lastTr.cashPaymentAmount = lastTr.cashPaymentAmount ? lastTr.cashPaymentAmount : 0;
  } else {
    newArr.push(createAccountsPayableCashCollectionNullTr());
  }

  newArr.push(lastTr);

  return newArr;
};



export const reverseAccountsPayableCashPaymentData = originAlArr => {
  let newArr = JSON.parse(JSON.stringify(originAlArr));

  newArr.map(obj => {


    if (typeof(obj.accountPayableBalance) == "string") {
      obj.accountPayableBalance = parseFloat(obj.accountPayableBalance.replace(/[^\d.-]/g, "")) || 0;
    }

    if (typeof(obj.cashPaymentAmount) == "string") {
      obj.cashPaymentAmount = parseFloat(obj.cashPaymentAmount.replace(/[^\d.-]/g, "")) || 0;
    }

    if (typeof(obj.accountPayableBalanceAfterPayment) == "string") {
      obj.accountPayableBalanceAfterPayment = parseFloat(obj.accountPayableBalanceAfterPayment.replace(/[^\d.-]/g, "")) || 0;
    }
    if (typeof(obj.billingDeadline) === "string") {
      obj.billingDeadline = parseFloat(obj.billingDeadline.replace(/[^\d.-]/g, "")) || 0;
    }

    if (typeof(obj.plannedDepositDate) == "string") {
      obj.plannedDepositDate = parseFloat(obj.plannedDepositDate.replace(/[^\d.-]/g, "")) || 0;
    }

    if (typeof(obj.paymentDueDate) === "string") {
      obj.paymentDueDate = parseFloat(obj.paymentDueDate.replace(/[^\d.-]/g, "")) || 0;
    }

    return obj;
  });

  return newArr;
};

export const weatherList = [
  {
    lable: locale("weather.sunny"),
    key: 1
  },
  {
    lable: locale("weather.cloudy"),
    key: 2
  },
  {
    lable: locale("weather.raining"),
    key: 3
  },
  {
    lable: locale("weather.thunderstorm"),
    key: 4
  },
  {
    lable: locale("weather.storm"),
    key: 5
  },
  {
    lable: locale("weather.snow"),
    key: 6
  },
  {
    lable: locale("weather.heavySnow"),
    key: 7
  }
];


/**
 *
 *
 *
 * For CreateDailyClosingDialog - OtherCashCollectionRegistrationTable
 *
 *
 */
export const formatOtherCashCollectionData = originAlArr => {
  let newArr = JSON.parse(JSON.stringify(originAlArr));

  newArr.map(obj => {
    obj.qty = obj.qty === 0 ? "" : obj.qty; //no "-" if 0
    obj.unitPrice = obj.unitPrice === 0 ? "" : obj.unitPrice; //no "-" if 0
    obj.cashCollectionAmount = obj.cashCollectionAmount === 0 ? "-" : obj.cashCollectionAmount;

    return obj;
  });

  return newArr;
};

export const createOtherCashCollectionNullTr = () => ({
  customerName: "",
  itemName: "",
  unitPrice: 0,
  qty: 0,
  unit: "",
  cashCollectionAmount: 0,
  details: ""
});


export const createOtherCashCollectionData = originAlArr => {
  let newArr = [];
  let lastTr = {
    unit: "合計額",
    cashCollectionAmount: 0
    //accountReceivableBalance: locale("dailyClosing.createDialog.accountsReceivableCashCollectionRegistrationTable.total"),
  }; //total row

  if (originAlArr.length > 0) {
    originAlArr.map(item => {
      let { cashCollectionAmount } = item;
      newArr.push({
        cashCollectionAmount: item.cashRecovery,
        customerName: item.clientId,
        details: item.details,
        itemName: item.otherRevenueId,
        unitPrice: item.price,
        qty: item.qty,
        unit: item.unit
      });
      lastTr.cashCollectionAmount += cashCollectionAmount;
    });
    lastTr.cashCollectionAmount = lastTr.cashCollectionAmount ? lastTr.cashCollectionAmount : 0;
  } else {
    newArr.push(createOtherCashCollectionNullTr());
  }

  newArr.push(lastTr);

  return newArr;
};



export const reverseOtherCashCollectionData = originAlArr => {
  let newArr = JSON.parse(JSON.stringify(originAlArr));

  newArr.map(obj => {


    if (typeof(obj.unitPrice) == "string") {
      obj.unitPrice = parseFloat(obj.unitPrice.replace(/[^\d.-]/g, "")) || 0;
    }

    if (typeof(obj.cashCollectionAmount) == "string") {
      obj.cashCollectionAmount = parseFloat(obj.cashCollectionAmount.replace(/[^\d.-]/g, "")) || 0;
    }

    if (typeof(obj.qty) == "string") {
      obj.qty = parseFloat(obj.qty.replace(/[^\d.-]/g, "")) || 0;
    }

    return obj;
  });

  return newArr;
};



/**
 *
 *
 *
 * For CreateDailyClosingDialog - OtherCashPaymentRegistrationTable
 *
 *
 */
export const formatOtherCashPaymentData = originAlArr => {
  let newArr = JSON.parse(JSON.stringify(originAlArr));

  newArr.map(obj => {
    obj.qty = obj.qty === 0 ? "" : obj.qty; //no "-" if 0
    obj.unitPrice = obj.unitPrice === 0 ? "" : obj.unitPrice; //no "-" if 0
    obj.cashPaymentAmount = obj.cashPaymentAmount === 0 ? "-" : obj.cashPaymentAmount;

    return obj;
  });

  return newArr;
};

export const createOtherCashPaymentNullTr = () => ({
  customerName: "",
  itemName: "",
  unitPrice: 0,
  qty: 0,
  unit: "",
  cashPaymentAmount: 0,
  details: ""
});


export const createOtherCashPaymentData = originAlArr => {
  let newArr = [];
  let lastTr = {
    unit: "合計額",
    cashPaymentAmount: 0
    //accountReceivableBalance: locale("dailyClosing.createDialog.accountsReceivableCashCollectionRegistrationTable.total"),
  }; //total row

  if (originAlArr.length > 0) {
    originAlArr.map(item => {
      let { cashPaymentAmount } = item;
      newArr.push({
        cashPaymentAmount: item.cashPayment,
        customerName: item.clientId,
        details: item.details,
        itemName: item.otherGoodsId,
        unitPrice: item.price,
        qty: item.qty,
        unit: item.unit
      });
      lastTr.cashPaymentAmount += cashPaymentAmount;
    });
    lastTr.cashPaymentAmount = lastTr.cashPaymentAmount ? lastTr.cashPaymentAmount : 0;
  } else {
    newArr.push(createOtherCashPaymentNullTr());
  }

  newArr.push(lastTr);

  return newArr;
};



export const reverseOtherCashPaymentData = originAlArr => {
  let newArr = JSON.parse(JSON.stringify(originAlArr));

  newArr.map(obj => {


    if (typeof(obj.unitPrice) == "string") {
      obj.unitPrice = parseFloat(obj.unitPrice.replace(/[^\d.-]/g, "")) || 0;
    }

    if (typeof(obj.cashPaymentAmount) == "string") {
      obj.cashPaymentAmount = parseFloat(obj.cashPaymentAmount.replace(/[^\d.-]/g, "")) || 0;
    }

    if (typeof(obj.qty) == "string") {
      obj.qty = parseFloat(obj.qty.replace(/[^\d.-]/g, "")) || 0;
    }

    return obj;
  });

  return newArr;
};



/**
 *
 *
 *
 * For CashTableDialog - allCashRegisterAmountsTable
 *
 *
 */
export const getEmptyAllCashRegisterAmountsTableData =  () => ([
  {
    content : locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.openAmount"), //内容
    amount : 0, //金額
    // prop: "openAmount",
    prop: "realOpenAmount",
    // apiProp: "openAmount",
    apiProp: "realOpenAmount",
    isBold: true
  },
  {
    content : locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.salesInCashes"), //内容
    amount : 0, //金額
    prop: "salesInCashes",
    apiProp: "salesInCashes",
    isBold: true
  },
  {
    content : locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.salesInCash"), //内容
    amount : 0, //金額
    prop: "salesInCash",
    apiProp: "salesInCash",
    paddingLevel: "padding-one", //padding left
  },
  {
    content : locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.ticket"), //内容
    amount : 0, //金額
    prop: "salesInCash_ticketAmount",
    apiProp: "salesInCash_ticketAmount",
    paddingLevel: "padding-two", //padding left
    isGrey : true
  },
  {
    content : locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.concession"), //内容
    amount : 0, //金額
    prop: "salesInCash_concessionGoodsPackageAmount",
    apiProp: "salesInCash_concessionGoodsPackageAmount",
    paddingLevel: "padding-two", //padding left
    isGrey : true
  },
  {
    content : locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.productSales"), //内容
    amount : 0, //金額
    prop: "salesInCash_commercialAmount",
    apiProp: "salesInCash_commercialAmount",
    paddingLevel: "padding-two", //padding left
    isGrey : true
  },
  {
    content : locale("report.cinemaDaily.membershipFree"), //内容
    amount : 0, //金額
    prop: "salesInCash_membershipFeeAmount",
    apiProp: "salesInCash_membershipFeeAmount",
    paddingLevel: "padding-two", //padding left
    isGrey : true
  },
  {
    content : locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.salesRefundInCash"), //内容
    amount : 0, //金額
    prop: "salesRefundInCash",
    apiProp: "salesRefundInCash",
    paddingLevel: "padding-one", //padding left
  },
  {
    content : locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.ticket"), //内容
    amount : 0, //金額
    prop: "salesRefundInCash_ticketAmount",
    apiProp: "salesRefundInCash_ticketAmount",
    paddingLevel: "padding-two", //padding left
    isGrey : true
  },
  {
    content : locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.concession"), //内容
    amount : 0, //金額
    prop: "salesRefundInCash_concessionGoodsPackageAmount",
    apiProp: "salesRefundInCash_concessionGoodsPackageAmount",
    paddingLevel: "padding-two", //padding left
    isGrey : true
  },
  {
    content : locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.productSales"), //内容
    amount : 0, //金額
    prop: "salesRefundInCash_commercialAmount",
    apiProp: "salesRefundInCash_commercialAmount",
    paddingLevel: "padding-two", //padding left
    isGrey : true
  },
  {
    content : locale("report.cinemaDaily.membershipFree"), //内容
    amount : 0, //金額
    prop: "salesRefundInCash_membershipFeeAmount",
    apiProp: "salesRefundInCash_membershipFeeAmount",
    paddingLevel: "padding-two", //padding left
    isGrey : true
  },
  {
    content : locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.preSaleInCash"), //内容
    amount : 0, //金額
    prop: "preSaleInCash",
    apiProp: "preSaleInCash",
    isBold: true
  },
  {
    content : locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.advanceTicketSale"), //内容
    amount : 0, //金額
    prop: "advanceTicketSale",
    apiProp: "advanceTicketSale",
    isBold: true
  },
  {
    content : locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.bondSales"), //内容
    amount : 0, //金額
    prop: "bondSales",
    apiProp: "bondSales",
    isBold: true
  },
  {
    content : locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.refundUpdateDetails"), //内容
    amount : 0, //金額
    prop: "refundUpdateDetails",
    apiProp: "refundUpdateDetails",
    isBold: true
  },
  {
    content : locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.cashAmount"), //内容
    amount : 0, //金額
    prop: "cashAmount",
    apiProp: "cashAmount",
  },
  {
    content : locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.midwayDeposit"), //内容
    amount : 0, //金額
    prop: "midwayDeposit",
    apiProp: "midwayDeposit",
  },
  {
    content : locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.cashierAmount"), //内容
    amount : 0, //金額
    prop: "cashierAmount",
    apiProp: "cashierAmount",
    isBold: true
  },
  {
    content : locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.cashSurplus"), //内容
    amount : 0, //金額
    prop: "cashSurplus",
    apiProp: "cashSurplus",
    isBold: true
  },
  {
    content : locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.changeReserve"), //内容
    amount : 0, //金額
    prop: "changeReserve",
    // prop: "realChargeReserve",
    apiProp: "changeReserve",
    // apiProp: "realChargeReserve"
  },
  {
    content : locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.deposit"), //内容
    amount : 0, //金額
    prop: "deposit",
    apiProp: "deposit",
    isBold: true
  },

]);

export const fillAllCashRegisterAmounts = ({ amountCalculationInfo: databaseData }) => {
  let tableData = getEmptyAllCashRegisterAmountsTableData();

  //re-arrange databaseData as a big object to match table display structure
  //check if one of the key is exist
  if (!databaseData || databaseData === undefined || !databaseData.salesInCashs) { return []; }

  const {
    // openAmount,
    realOpenAmount,
    salesInCash: {
      commercialAmount,
      concessionGoodsPackageAmount,
      ticketAmount,
      membershipFeeAmount
    },
    salesRefundInCash: {
      commercialAmount: refundCommercialAmount,
      concessionGoodsPackageAmount: refundPackageAmount,
      ticketAmount: refundTicketAmount,
      membershipFeeAmount: refundMembershipFeeAmount
    },
    preSaleInCash,
    advanceTicketSale,
    bondSales,
    refundUpdateDetails,
    cashAmount,
    cashierAmount,
    cashSurplus,
    changeReserve,
    // realChargeReserve,
    deposit,
    midwayDeposit
  } = databaseData.salesInCashs;
  const _salesInCashAmount = commercialAmount + concessionGoodsPackageAmount + ticketAmount + membershipFeeAmount;
  const _refundInCashAmount = refundCommercialAmount + refundPackageAmount + refundTicketAmount + refundMembershipFeeAmount;

  let newDatabaseData = {
    // openAmount,
    realOpenAmount,
    salesInCashes: _salesInCashAmount - _refundInCashAmount,
    salesInCash : _salesInCashAmount,
    salesInCash_ticketAmount : ticketAmount,
    salesInCash_concessionGoodsPackageAmount : concessionGoodsPackageAmount,
    salesInCash_commercialAmount : commercialAmount, //物販
    salesInCash_membershipFeeAmount : membershipFeeAmount,

    salesRefundInCash : _refundInCashAmount,
    salesRefundInCash_ticketAmount : refundTicketAmount,
    salesRefundInCash_concessionGoodsPackageAmount : refundPackageAmount,
    salesRefundInCash_commercialAmount : refundCommercialAmount, //物販
    salesRefundInCash_membershipFeeAmount: refundMembershipFeeAmount,

    preSaleInCash,
    advanceTicketSale,
    bondSales,
    refundUpdateDetails,
    cashAmount,
    cashierAmount,
    cashSurplus,
    changeReserve,
    // realChargeReserve,
    deposit,
    midwayDeposit,
  };

  //insert amount into tableData and format
  tableData.map(row => {
    let amount = newDatabaseData[row.apiProp];
    if(typeof(amount) === "number") {
      // amount = amount.toLocaleString();
      row.amount = amount;
    }
  });

  return tableData;
};




/**
 *
 *
 *
 * For CashTableDialog - cashTypeTable 金庫金種表
 *
 *
 */
export const cashTypeMapping = [ //hard code based on api key
  {
    label: "10,000" + locale("cashierReport.dialog.bills"),
    key: "bill10000",
    value: 10000
  },
  {
    label: "5,000" + locale("cashierReport.dialog.bills"),
    key: "bill5000",
    value: 5000
  },
  {
    label: "2,000" + locale("cashierReport.dialog.bills"),
    key: "bill2000",
    value: 2000
  },
  {
    label: "1,000" + locale("cashierReport.dialog.bills"),
    key: "bill1000",
    value: 1000
  },
  {
    label: "500" + locale("cashierReport.dialog.coins"),
    key: "coin500",
    value: 500
  },
  {
    label: "100" + locale("cashierReport.dialog.coins"),
    key: "coin100",
    value: 100
  },
  {
    label: "50" + locale("cashierReport.dialog.coins"),
    key: "coin50",
    value: 50
  },
  {
    label: "10" + locale("cashierReport.dialog.coins"),
    key: "coin10",
    value: 10
  },
  {
    label: "5" + locale("cashierReport.dialog.coins"),
    key: "coin5",
    value: 5
  },
  {
    label: "1" + locale("cashierReport.dialog.coins"),
    key: "coin1",
    value: 1
  },
];

export const fillCashTypeTable = detailData => {
  const { amountCalculationInfo: { actualCash } = {} } = detailData;
  if (!actualCash) { return []; }

  let arr = [];
  let _latRowAmont = 0;

  cashTypeMapping.map(type => {
    const { key, value } = type;
    const _qty = actualCash[key] ? actualCash[key] : 0;
    const _amount = _qty * value;

    if (typeof _amount === "number") {
      _latRowAmont += _amount;
    }

    const row = {
      cashType: type.label,
      qty : _qty,
      amount: _amount,
      value, //for calulation only, will not display
      key, //for construct post data
    };

    arr.push(row);
  });

  const lastRow = {
    prop: "safeTotalToday",
    cashType: locale("dailyClosing.cashTableDialog.cashTypeTable.todaySafeTotal"),
    amount: _latRowAmont,
  };

  arr.push(lastRow);

  return arr;

};


/**
 *
 * For CashTableDialog - cashSettlementTable 金庫精算表
 * REF link:
 * https://gtjp.atlassian.net/browse/DEV-3845
 * https://gtjp.atlassian.net/browse/DEV-5383
 *
 */
export const getEmptyCashSettlementTableData =  () => ([
  {
    content : locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.treasuryRemnant"), //内容
    amount : 0, //金額
    displayValue: 0,
    prop: "treasuryRemnant",
    apiProp: "treasuryRemnant",
    isBold: true,
  },
  {
    content : locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.cashier"), //内容
    amount : 0, //金額
    displayValue: 0,
    prop: "cashier",
    apiProp: "cashier",
  },
  {
    content : locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.cashRecoveryPayment"), //内容
    amount : 0, //金額
    displayValue: 0,
    prop: "cashRecoveryPayment",
    apiProp: "cashRecoveryPayment",
  },
  {
    content : locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.cashRecoveryPayment_cashRecoveryAccounts"), //内容
    amount : 0, //金額
    displayValue: 0,
    prop: "cashRecoveryPayment_cashRecoveryAccounts",
    apiProp: "cashRecoveryPayment_cashRecoveryAccounts",
    paddingLevel: "padding-one", //padding left
    isGrey : true
  },
  {
    content : locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.cashRecoveryPayment_otherRevenueCash"), //内容
    amount : 0, //金額
    displayValue: 0,
    prop: "cashRecoveryPayment_otherRevenueCash",
    apiProp: "cashRecoveryPayment_otherRevenueCash",
    paddingLevel: "padding-one", //padding left
    isGrey : true
  },
  {
    content : locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.cashRecoveryPayment_cashPayment"), //内容
    amount : 0, //金額
    displayValue: 0,
    prop: "cashRecoveryPayment_cashPayment",
    apiProp: "cashRecoveryPayment_cashPayment",
    paddingLevel: "padding-one", //padding left
    isGrey : true
  },
  {
    content : locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.cashRecoveryPayment_otherCashPayment"), //内容
    amount : 0, //金額
    displayValue: 0,
    prop: "cashRecoveryPayment_otherCashPayment",
    apiProp: "cashRecoveryPayment_otherCashPayment",
    paddingLevel: "padding-one", //padding left
    isGrey : true
  },
  {
    content : locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.smallCashTransfer"), //内容
    amount : 0, //金額
    displayValue: 0,
    prop: "smallCashTransfer",
    apiProp: "smallCashTransfer",
    isBold: true,
    input: true
  },
  {
    content : locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.dayTreasury"), //内容
    amount : 0, //金額
    displayValue: 0,
    prop: "dayTreasury",
    apiProp: "dayTreasury",
    isBold: true,
  },
  {
    content : locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.addCash"), //内容
    amount : 0, //金額
    displayValue: 0,
    prop: "addCash",
    apiProp: "addCash",
    isBold: true,
  },
  {
    content : locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.safeTotalToday"), //内容
    amount : 0, //金額
    displayValue: 0,
    prop: "safeTotalToday",
    apiProp: "safeTotalToday",
    isBold: true
  },
  {
    content : locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.totalInsufficient"), //内容
    amount : 0, //金額
    displayValue: 0,
    prop: "totalInsufficient",
    apiProp: "totalInsufficient",
    paddingLevel: "padding-one", //padding left
    isBold: true
  },
  {
    content : locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.totalInsufficient_cashierArrears"), //内容
    amount : 0, //金額
    displayValue: 0,
    prop: "totalInsufficient_cashierArrears",
    apiProp: "totalInsufficient_cashierArrears",
    paddingLevel: "padding-two", //padding left
    isGrey : true

  },
  {
    content : locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.totalInsufficient_treasuryBalance"), //内容
    amount : 0, //金額
    displayValue: 0,
    prop: "totalInsufficient_treasuryBalance",
    apiProp: "totalInsufficient_treasuryBalance",
    paddingLevel: "padding-two", //padding left
    isGrey : true
  },
  {
    content : locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.pettyCash"), //内容
    amount : 0, //金額
    displayValue: 0,
    prop: "pettyCash",
    apiProp: "pettyCash",
    input: true,
    isBold: true
  },
  {
    content : locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.cashPrevious"), //内容
    amount : 0, //金額
    displayValue: 0,
    prop: "cashPrevious",
    apiProp: "cashPrevious",
    isBold: true
  },
  {
    content : locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.depositAmount"), //内容
    amount : 0, //金額
    displayValue: 0,
    prop: "depositAmount",
    apiProp: "depositAmount",
    isBold: true,
    input: true
  },
  {
    content : locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.balanceTransferred"), //内容
    amount : 0, //金額
    displayValue: 0,
    prop: "balanceTransferred",
    apiProp: "balanceTransferred",
    input: true,
    isBold: true
  },
  {
    content : locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.cashCarried"), //内容
    amount : 0, //金額
    displayValue: 0,
    prop: "cashCarried",
    apiProp: "cashCarried",
    isBold: true
  },

]);

export const fillCashSettlementAmounts = ({ amountCalculationInfo: databaseData }) => {
  if (!databaseData || !databaseData.accuratelyCalculate || !databaseData.salesInCashs) { return []; }

  let tableData = getEmptyCashSettlementTableData();

  //re-arrange databaseData as a big object to match table display structure
  //check if one of the key is exist
  const {
    bondSales, //全国共通券販売
    advanceTicketSale, //劇場前売券販売
    refundUpdateDetails, //レジ締め済等取引の追加/払戻/修正
  } = databaseData.salesInCashs;

  const {
    treasuryRemnant, //前日金庫残 = 該cinema前一次day close時的繰越金庫残金額
    cashier, //金庫預入金（レジ） = 全レジ内金額の内訳計算表  內的  金庫預入金 (¥393,000)
    cashRecoveryPayment: {
      cashPayment,
      cashRecoveryAccounts,
      otherCashPayment,
      otherRevenueCash,
    },
    smallCashTransfer, //小口現金振替 = default blank, free input by user
    // dayTreasury,
    // addCash,
    // safeTotalToday,
    totalInsufficient: {
      cashierArrears, //（レジ過不足金）
      // treasuryBalance,
    },
    cashPrevious, //前日未預入現金
    depositAmount, //預金金額
    balanceTransferred, //繰越金庫残金額
    pettyCash, //過不足小口現金振替
    // cashCarried,
  } = databaseData.accuratelyCalculate;

  const _cashRecoveryPayment = cashRecoveryAccounts + otherRevenueCash - cashPayment - otherCashPayment;
  //↑ 現金回収支払合計 = sum of the 4 indented item
  const {
    salesInCash: {
      commercialAmount,
      concessionGoodsPackageAmount,
      ticketAmount,
    },
    salesRefundInCash: {
      commercialAmount: commercialAmount_refund,
      concessionGoodsPackageAmount: concessionGoodsPackageAmount_refund,
      ticketAmount: ticketAmount_refund,
    },
    preSaleInCash, //前受金（先売等）
  } = databaseData.salesInCashs;

  let _safeTotalToday = 0; //本日金庫合計 = 金庫金種表. 本日金庫合計
  cashTypeMapping.map(type => {
    const { key, value } = type;
    const _qty = databaseData.actualCash[key] ? databaseData.actualCash[key] : 0;
    const _amount = _qty * value;
    _safeTotalToday += _amount;
  });
  const _smallCashTransfer = isNaN(Number(smallCashTransfer)) ? 0 : Number(smallCashTransfer);
  const _pettyCash = isNaN(Number(pettyCash)) ? 0 : Number(pettyCash);
  const _depositAmount = isNaN(Number(depositAmount)) ? 0 : Number(depositAmount);
  const _balanceTransferred = isNaN(Number(balanceTransferred)) ? 0 : Number(balanceTransferred);
  const _dayTreasury = treasuryRemnant + cashier + _cashRecoveryPayment + _smallCashTransfer;
  //↑ 理論当日金庫合計 = 前日金庫残 + 金庫預入金（レジ） + 現金回収支払合計 + 小口現金振替
  const _treasuryBalance = _safeTotalToday - _dayTreasury; //（金庫過不足金）= 本日金庫合計 - 理論当日金庫合計
  const totalSalesInCash = (commercialAmount + concessionGoodsPackageAmount + ticketAmount) - (commercialAmount_refund + concessionGoodsPackageAmount_refund + ticketAmount_refund);
  //↑ 本日現金売上
  const _addCash = totalSalesInCash + preSaleInCash + bondSales + advanceTicketSale + _cashRecoveryPayment + _smallCashTransfer + treasuryRemnant - refundUpdateDetails;
  //↑ ※本日売上＋前日金庫残 = 本日現金売上 + 前受金（先売等） + 全国共通券販売 + 劇場前売券販売 + 現金回収支払合計 + 小口現金振替 + 前日金庫残 - レジ締め済等取引の追加/払戻/修正
  const _totalInsufficient = cashierArrears + _treasuryBalance;
  // const _totalInsufficient = _safeTotalToday - _addCash;
  //↑（過不足金合計） = （レジ過不足金） + （金庫過不足金） || 【 本日金庫合計 - ※本日売上＋前日金庫残 】
  // const _pettyCash = _addCash - _safeTotalToday; //過不足小口現金振替, default blank, 當公式內的數值有value/有改變時自動重新計算= (※本日売上＋前日金庫残) - (本日金庫合計)
  const _cashCarried = _safeTotalToday + _pettyCash + cashPrevious - _depositAmount - _balanceTransferred;
  //↑ 繰越未預入現金（cashCarried）= 本日金庫合計 + 過不足小口現金振替 + 前日未預入現金 - 預金金額 - 繰越金庫残金額

  let newDatabaseData = {
    treasuryRemnant,
    cashier,
    cashRecoveryPayment: _cashRecoveryPayment,
    cashRecoveryPayment_cashRecoveryAccounts: cashRecoveryAccounts,
    cashRecoveryPayment_otherRevenueCash: otherRevenueCash,
    cashRecoveryPayment_cashPayment: cashPayment,
    cashRecoveryPayment_otherCashPayment: otherCashPayment,
    smallCashTransfer: _smallCashTransfer, //need input
    dayTreasury: _dayTreasury,
    addCash: _addCash,
    safeTotalToday: _safeTotalToday, //suppose getting another table data
    totalInsufficient: _totalInsufficient,
    totalInsufficient_cashierArrears: cashierArrears,
    totalInsufficient_treasuryBalance: _treasuryBalance,
    // pettyCash: _pettyCash, //need input
    pettyCash: _pettyCash,
    cashPrevious,
    depositAmount: _depositAmount, //need input
    balanceTransferred: _balanceTransferred, //need input
    cashCarried: _cashCarried, //need cal
  };

  //insert amount into tableData
  const targetArr = ["cashRecoveryPayment_cashPayment", "cashRecoveryPayment_otherCashPayment"];

  tableData.map(row => {
    let amount = targetArr.indexOf(row.apiProp) > -1 ? -newDatabaseData[row.apiProp] : newDatabaseData[row.apiProp];
    row.amount = amount;
    // if (typeof(amount) === "number") {
    //   amount = toThousands(amount);
    //   row.amount = _YEN + amount;
    // }else{
    //   //null
    //   row.amount = amount;
    // }
  });

  return tableData;
};


/**
 *
 *
 *
 * For AccountsReceivableTableDialog - allCashRegisterAmountsTableData
 *
 *
 */

export const reverseArAllCashRegisterAmountsData = originAlArr => {
  let newArr = JSON.parse(JSON.stringify(originAlArr));

  newArr.map(obj => {


    if (typeof(obj.dayActualQty) === "string" && obj.dayActualQty !== "-") {
      obj.dayActualQty = parseFloat(obj.dayActualQty.replace(/[^\d.-]/g, "")) || 0;
    }


    if (typeof(obj.registrationTheorySales) == "string") {
      obj.registrationTheorySales = obj.registrationTheorySales.replace(_YEN, "");
      obj.registrationTheorySales = parseFloat(obj.registrationTheorySales.replace(/[^\d.-]/g, "")) || 0;
    }

    if (typeof(obj.actualCashRegisterSales) == "string") {
      obj.actualCashRegisterSales = parseFloat(obj.actualCashRegisterSales.replace(/[^\d.-]/g, "")) || 0;
    }

    if (typeof(obj.registrationExcessDeficiencySales) == "string") {
      obj.registrationExcessDeficiencySales = parseFloat(obj.registrationExcessDeficiencySales.replace(/[^\d.-]/g, "")) || 0;
    }

    //prevent update dayActualQty will trigger actualSales update
    if (obj.actualSales !== "-" && obj.actualSales !== undefined &&  obj.actualSales !== null && typeof(obj.actualSales) == "string") {
      obj.actualSales = parseFloat(obj.actualSales.replace(/[^\d.-]/g, "")) || 0;
    }


    return obj;
  });
  return newArr;
};


export const formatArAllCashRegisterAmountsData = originAlArr => {
  let newArr = JSON.parse(JSON.stringify(originAlArr));
  //reverse all data to number again
  newArr  = reverseArAllCashRegisterAmountsData(newArr);

  newArr.map(obj => {
    obj.registrationTheorySales = _YEN + toThousands(obj.registrationTheorySales);
    obj.actualCashRegisterSales = _YEN + toThousands(obj.actualCashRegisterSales);
    obj.registrationExcessDeficiencySales = _YEN + toThousands(obj.registrationExcessDeficiencySales);
    obj.dayActualQty =  obj.dayActualQty === null || obj.dayActualQty === undefined   ? "-" :  toThousands(obj.dayActualQty) ;

    if(obj.rowType === "normal" || obj.rowType === "empty-row") {
      obj.actualSales =  obj.actualSales === null ? "-" :  obj.actualSales === "-" ? obj.actualSales : _YEN + toThousands(obj.actualSales) ;
    }else if(obj.rowType === "subtotal" || obj.rowType === "total") {
      obj.actualSales =  obj.actualSales === null ? "-" : obj.actualSales === "-" ? obj.actualSales : _YEN + toThousands(obj.actualSales) ;
    }

    return obj;
  });

  return newArr;
};

export const createArAllCashRegisterAmountsNullTr = (arType, label) => ({
  rowType: "empty-row",
  arType: arType,
  accountsReceivableType: label,
  accountReceivableName: null,
  numberOfCashRegisterTheories: 0,
  actualNumberOfRegistrations: 0,
  excessDeficiencyOfRegistration: 0,
  dayActualQty:null,
  registrationTheorySales:0,
  actualCashRegisterSales:0,
  registrationExcessDeficiencySales: 0,
  actualSales: null,
  price: null
});

/**
 *
 *
 *
 * For AccountsReceivableTableDialog - PastBusinessDayTransactionsTable
 *
 *
 */


export const reversePastBusinessDayTransactionsTableData = originAlArr => {
  let newArr = JSON.parse(JSON.stringify(originAlArr));

  newArr.map(obj => {

    if (typeof(obj.amount) == "string") {
      obj.amount = obj.amount.replace(_YEN, "");
      obj.amount = parseFloat(obj.amount.replace(/[^\d.-]/g, "")) || 0;
    }

    if (typeof(obj.actualAmount) == "string") {
      obj.actualAmount = obj.actualAmount.replace(_YEN, "");
      obj.actualAmount = parseFloat(obj.actualAmount.replace(/[^\d.-]/g, "")) || 0;
    }


    if (typeof(obj.actualSales) == "string") {
      obj.actualSales = obj.actualSales.replace(_YEN, "");
      obj.actualSales = parseFloat(obj.actualSales.replace(/[^\d.-]/g, "")) || 0;
    }

    return obj;
  });
  return newArr;
};


export const formatPastBusinessDayTransactionsTableData = originAlArr => {
  let newArr = JSON.parse(JSON.stringify(originAlArr));
  //reverse all data to number again
  newArr  = reversePastBusinessDayTransactionsTableData(newArr);

  newArr.map(obj => {
    //NOTE all numbers are positive but need to display as negative
    obj.qty = typeof(obj.qty) === "number" ?  (obj.qty > 0 ?  "-" + (obj.qty) : (obj.qty))  : "-";
    obj.actualQty = typeof(obj.actualQty) === "number" ?  (obj.actualQty > 0 ?  "-" + (obj.actualQty) : (obj.actualQty))  : "-";
    obj.dayActualQty = typeof(obj.dayActualQty) === "number" ?  (obj.dayActualQty > 0 ?  "-" + (obj.dayActualQty) : (obj.dayActualQty))  : "-";

    obj.amount = typeof(obj.amount) === "number" ?  obj.amount > 0 ?  "¥-" + toThousands(obj.amount) : _YEN + toThousands(obj.amount)  : "-";
    obj.actualAmount = typeof(obj.actualAmount) === "number"  ? obj.actualAmount > 0 ?  "¥-" + toThousands(obj.actualAmount) : _YEN + toThousands(obj.actualAmount)  : "-" ;
    obj.actualSales = typeof(obj.actualSales) === "number" ?  obj.actualSales > 0 ?  "¥-" + toThousands(obj.actualSales) : _YEN + toThousands(obj.actualSales)  :   "-";

    // if(obj.rowType === "normal") {

    // }else if(obj.rowType === "subtotal" || obj.rowType === "total") {

    // }

    return obj;
  });

  return newArr;
};



/**
 *
 *
 *
 * For AccountsReceivableTableDialog - ExcessDeficiencySettlementTable
 *
 *
 */
export const isNumber = n => { return !isNaN(parseFloat(n)) && !isNaN(n - 0); };

export const reverseExcessDeficiencySettlementData = originAlArr => {
  let newArr = JSON.parse(JSON.stringify(originAlArr));

  newArr.map(obj => {


    if (typeof(obj.dayActualQty) == "string") {
      obj.dayActualQty = parseFloat(obj.dayActualQty.replace(/[^\d.-]/g, "")) || 0;
    }


    if (typeof(obj.registrationTheorySales) == "string") {
      obj.registrationTheorySales = obj.registrationTheorySales.replace(_YEN, "");
      obj.registrationTheorySales = parseFloat(obj.registrationTheorySales.replace(/[^\d.-]/g, "")) || 0;
    }

    if (typeof(obj.actualCashRegisterSales) == "string") {
      obj.actualCashRegisterSales = parseFloat(obj.actualCashRegisterSales.replace(/[^\d.-]/g, "")) || 0;
    }

    if (typeof(obj.registrationExcessDeficiencySales) == "string") {
      obj.registrationExcessDeficiencySales = parseFloat(obj.registrationExcessDeficiencySales.replace(/[^\d.-]/g, "")) || 0;
    }

    if (typeof(obj.actualSales) == "string") {
      obj.actualSales = parseFloat(obj.actualSales.replace(/[^\d.-]/g, "")) || 0;
    }


    return obj;
  });
  return newArr;
};


export const formatExcessDeficiencySettlementData = originAlArr => {
  let newArr = JSON.parse(JSON.stringify(originAlArr));
  //reverse all data to number again
  newArr  = reverseExcessDeficiencySettlementData(newArr);

  newArr.map(obj => {

    obj.dayActualQty = obj.dayActualQty === null ?  "-" : toThousands(obj.dayActualQty);
    obj.insufficientTotal = obj.insufficientTotal === null ?  "-" : toThousands(obj.insufficientTotal);
    obj.cashQty = obj.cashQty === null ?  "-" : toThousands(obj.cashQty);
    obj.dayQty = obj.dayQty === null ?  "-" : toThousands(obj.dayQty);

    obj.saleQty = typeof(obj.saleQty) === "number" ? _YEN + toThousands(obj.saleQty): "-";
    obj.cashBalance = typeof(obj.cashBalance) === "number" ? _YEN + toThousands(obj.cashBalance) :  "-" ;
    obj.dayInsufficient = typeof(obj.dayInsufficient) === "number" ? _YEN + toThousands(obj.dayInsufficient) :  "-";

    if(obj.actualSales != "-") {
      obj.actualSales = obj.actualSales === null ?  "-" : _YEN + toThousands(obj.actualSales);
    }

    if(obj.rowType === "normal") {

      // obj.dayActualQty = obj.dayActualQty === null ?  "-" : obj.dayActualQty;
      // obj.insufficientTotal = obj.insufficientTotal === null ?  "-" : obj.insufficientTotal;
      // obj.cashQty = obj.cashQty === null ?  "-" : obj.cashQty;
      // obj.dayQty = obj.dayQty === null ?  "-" : obj.dayQty;

      // obj.saleQty = typeof(obj.saleQty) === "number" ?   _YEN + toThousands(obj.saleQty): "-";
      // obj.cashBalance = typeof(obj.cashBalance) === "number" ? _YEN + toThousands(obj.cashBalance) :  "-" ;
      // obj.dayInsufficient = typeof(obj.dayInsufficient) === "number" ?  _YEN + toThousands(obj.dayInsufficient) :  "-";

      // if(obj.actualSales != "-") {
      //   obj.actualSales = obj.actualSales === null ?  "-" : _YEN + toThousands(obj.actualSales);
      // }

    }else if(obj.rowType === "subtotal" || obj.rowType === "total") {
      // obj.dayActualQty =  obj.dayActualQty  > 0 ? obj.dayActualQty : "-";
      // obj.actualSales = obj.actualSales > 0 ?  _YEN + toThousands(obj.actualSales) : "-";

    }

    return obj;
  });

  return newArr;
};


export const createExcessDeficiencySettlementNullTr = () => ({
  arType: "",
  rowType: "",
  accountsReceivableType: "",
  accountReceivableName: "",
  dayActualQty: null,
  insufficientTotal: null,
  cashQty: null,
  dayQty: null,
  actualSales: null,
  saleQty: null,
  cashBalance: null,
  dayInsufficient: null
});











/**
 *
 *
 *
 * For AccountsReceivableTableDialog - OtherOperatingIncomeAccountsReceivableRegistrationTable
 *
 *
 */
export const formatOtherOperatingIncomeAccountsReceivableRegistrationData = originAlArr => {
  let newArr = JSON.parse(JSON.stringify(originAlArr));

  newArr.map(obj => {

    obj.qty = obj.qty === 0 ? "" : toThousands(obj.qty); //no "-" if 0
    obj.unitPrice = obj.unitPrice === 0 ? "" : toThousands(obj.unitPrice); //no "-" if 0

    if(obj.billingAmount !== "-") {
      obj.billingAmount = obj.billingAmount === 0 ? "-" :  _YEN +  toThousands(obj.billingAmount);
    }

    return obj;
  });

  return newArr;
};

export const createOtherOperatingIncomeAccountsReceivableRegistrationNullTr = () => ({
  customerName: "",
  itemName: "",
  unitPrice: 0,
  qty: 0,
  unit: "",
  billingAmount: 0,
  details: ""
});


export const createOtherOperatingIncomeAccountsReceivableRegistrationData = originAlArr => {
  let newArr = [];
  let lastTr = {
    unit: "合計額",
    billingAmount: 0
    //accountReceivableBalance: locale("dailyClosing.createDialog.accountsReceivableCashCollectionRegistrationTable.total"),
  }; //total row

  if (originAlArr.length > 0) {
    originAlArr.map(item => {
      let { billingAmount } = item;
      newArr.push({
        ...item,
      });
      lastTr.billingAmount += billingAmount;
    });
    lastTr.billingAmount = lastTr.billingAmount ? lastTr.billingAmount : 0;
  } else {
    newArr.push(createOtherOperatingIncomeAccountsReceivableRegistrationNullTr());
  }

  newArr.push(lastTr);
  return newArr;
};



export const reverseOtherOperatingIncomeAccountsReceivableRegistrationData = originAlArr => {
  let newArr = JSON.parse(JSON.stringify(originAlArr));

  newArr.map(obj => {

    if (typeof(obj.unitPrice) == "string") {
      obj.unitPrice = parseFloat(obj.unitPrice.replace(/[^\d.-]/g, "")) || 0;
    }

    if (typeof(obj.qty) === "string" && (obj.qty) !== "-") {
      obj.qty = obj.qty.replace(_YEN, "");
      obj.qty = parseFloat(obj.qty.replace(/[^\d.-]/g, "")) || 0;
    }else if((obj.qty) === "-") {
      obj.qty = 0;
    }

    if (typeof(obj.billingAmount) === "string" && (obj.billingAmount) !== "-") {
      obj.billingAmount = obj.billingAmount.replace(_YEN, "");
      obj.billingAmount = parseFloat(obj.billingAmount.replace(/[^\d.-]/g, "")) || 0;
    }else if((obj.billingAmount) === "-") {
      obj.billingAmount = 0;
    }

    return obj;
  });

  return newArr;
};




/**//////////// */



// export const formatOtherPurchaseData = originAlArr => {
//   let newArr = JSON.parse(JSON.stringify(originAlArr));

//   newArr.map(obj => {
//     obj.otherGoodsInfo.price = obj.otherGoodsInfo.price == 0 ? "-" : obj.otherGoodsInfo.price;
//     obj.otherGoodsInfo.inventory = obj.otherGoodsInfo.inventory == 0 ? "-" : obj.otherGoodsInfo.inventory;
//     obj.priceTotal = obj.priceTotal == 0 ? "-" : obj.priceTotal;

//     return obj;
//   });

//   return newArr;
// };


export const formatPaymentTableData = (originAlArr, dataType = "TICKETING") => {
  let newArr = [];
  let lastTr = {
    dateInterval: locale("accountPayable.trTotal"),
    income: 0,
    actualNumber: 0,
    needPayAmount: 0,
    payAmount: 0,
    payMoney: 0,
    adjustment: 0,
    offset: 0,
    accountPayableBalance: 0,
  };

  originAlArr.map(item => {
    let obj = {};

    obj.cinemaName = item.cinemaName;
    obj.clientName = item.clientName;
    obj.filmName = "";
    obj.dateInterval = "";
    obj.income = 0;
    obj.actualNumber = 0;
    obj.needPayAmount = 0;
    obj.payAmount = 0;

    obj.payMoney = item.payMoney || 0;
    obj.adjustment = item.adjustment || 0;
    obj.offset = item.offset || 0;
    obj.accountPayableBalance = 0;

    if (dataType == "TICKETING") {
      obj.filmName = item.filmName;

      obj.dateInterval = item.ticketing.dateInterval;
      obj.needPayAmount = item.ticketing.needPayAmount;

      Object.keys(item.ticketing.amountDetail).map(keyName => {
        obj.income += item.ticketing.amountDetail[keyName].income;
      });

      lastTr.income += obj.income;
      lastTr.actualNumber += item.ticketing.actualNumber;

      obj.income = obj.income.toLocaleString();
      obj.actualNumber = item.ticketing.actualNumber.toLocaleString();
    }

    if (dataType == "BUY") {
      obj.productName = item.storeName;

      obj.dateInterval = item.buy.dateInterval;
      obj.needPayAmount = item.buy.needPayAmount;
    }

    if (dataType == "PROXY_BUY") {
      obj.productName = item.storeName;

      obj.dateInterval = item.proxyBuy.dateInterval;
      obj.needPayAmount = item.proxyBuy.needPayAmount;
    }

    obj.accountPayableBalance = obj.needPayAmount - obj.payMoney - obj.adjustment - obj.offset;

    lastTr.needPayAmount += obj.needPayAmount;
    lastTr.payMoney += obj.payMoney;
    lastTr.adjustment += obj.adjustment;
    lastTr.offset += obj.offset;
    lastTr.accountPayableBalance += obj.accountPayableBalance;

    obj.accountPayableBalance = obj.accountPayableBalance.toLocaleString();
    obj.needPayAmount = obj.needPayAmount.toLocaleString();

    newArr.push(obj);
  });

  lastTr.income = lastTr.income.toLocaleString();
  lastTr.actualNumber = lastTr.actualNumber.toLocaleString();
  lastTr.needPayAmount = lastTr.needPayAmount.toLocaleString();
  lastTr.payMoney = lastTr.payMoney.toLocaleString();
  lastTr.adjustment = lastTr.adjustment.toLocaleString();
  lastTr.offset = lastTr.offset > 0 ? lastTr.offset.toLocaleString() : "";
  lastTr.accountPayableBalance = lastTr.accountPayableBalance.toLocaleString();

  newArr.push(lastTr);

  return newArr;
};

export const formatPaymentOtherTableData = (originAlArr, cinemaList, clientList) => {
  let newArr = [];
  let lastTr = {
    dateInterval: locale("accountPayable.trTotal"),
    needPayAmount: 0,
    payAmount: 0,
    payMoney: 0,
    adjustment: 0,
    offset: 0,
    accountPayableBalance: 0,
  };
  let cinemaArr = [];
  let clientArr = [];

  cinemaList.map(item => {
    cinemaArr.push(item.id);
    cinemaArr.push(item.name);
  });

  clientList.map(item => {
    clientArr.push(item.id);
    clientArr.push(item.name);
  });

  originAlArr.map(item => {
    let obj = {
      cinemaId: item.cinemaId,
      clientId: item.clientId,
      name: item.otherGoodsInfo.name,
      dateInterval: item.dateInterval,
      needPayAmount: 0,
      payAmount: item.payAmount,
      payMoney: item.payMoney,
      adjustment: item.adjustment,
      offset: item.offset,
      accountPayableBalance: 0,
    };
    let cinemaIndex = cinemaArr.indexOf(obj.cinemaId);
    let clientIndex = clientArr.indexOf(obj.clientId);

    obj.cinemaName = cinemaArr[cinemaIndex + 1];
    obj.clientName = clientArr[clientIndex + 1];
    obj.needPayAmount = item.needPayAmount > 0 ? item.needPayAmount : item.otherGoodsInfo.inventory * item.otherGoodsInfo.price;// do some thing
    obj.accountPayableBalance = obj.needPayAmount - obj.payMoney - obj.adjustment - obj.offset;

    lastTr.needPayAmount += obj.needPayAmount;
    lastTr.payAmount += obj.payAmount;
    lastTr.payMoney += obj.payMoney;
    lastTr.adjustment += obj.adjustment;
    lastTr.offset += obj.offset;
    lastTr.accountPayableBalance += obj.accountPayableBalance;

    obj.needPayAmount = obj.needPayAmount.toLocaleString();
    obj.payAmount = obj.payAmount.toLocaleString();
    obj.accountPayableBalance = obj.accountPayableBalance.toLocaleString();

    newArr.push(obj);
  });

  lastTr.needPayAmount = lastTr.needPayAmount.toLocaleString();
  lastTr.payAmount = lastTr.payAmount.toLocaleString();
  lastTr.payMoney = lastTr.payMoney.toLocaleString();
  lastTr.adjustment = lastTr.adjustment.toLocaleString();
  lastTr.offset = lastTr.offset > 0 ? lastTr.offset.toLocaleString() : "";
  lastTr.accountPayableBalance = lastTr.accountPayableBalance.toLocaleString();

  newArr.push(lastTr);

  return newArr;
};

export const createPaymentForm = () => {
  return {
    accountPayableId: "",
    actualAmountResidual: 0,
    brandId: "",
    date: 0,
    name: "",
    type: "",
    typeDetail: "",
    payAmount: 0,
    payMoney: 0,
    payDetails: [],
  };
};

export const createPaymentTypeOption = () => {
  const typeOption = [
    {
      label: locale("accountPayable.accountPayment"),
      value: "ACCOUNT",
      child: [
        {
          label: locale("accountPayable.fromDepositDestination"),
          value: locale("accountPayable.fromDepositDestination"),
        }
      ],
    },
    {
      label: locale("accountPayable.offset"),
      value: "OFFSET",
      child: [
        {
          label: locale("accountPayable.fromAccountReceivableStatement"),
          value: locale("accountPayable.fromAccountReceivableStatement"),
        },
        {
          label: locale("accountPayable.offsetPaymentStatement"),
          value: locale("accountPayable.offsetPaymentStatement"),
        }
      ],
    },
    {
      label: locale("accountPayable.cash"),
      value: "CASH",
      child: [
        {
          label: locale("accountPayable.autoCash"),
          value: locale("accountPayable.autoCash"),
        }
      ],
    }
  ];

  return typeOption;
};

export const formatPaymentListData = originAlArr => {
  let newArr = [];
  let thead = [
    {
      label: locale("accountPayable.paymentDate"),
      prop: "date",
    },
    {
      label: locale("accountPayable.paymentName"),
      prop: "name",
    },
    {
      label: locale("accountPayable.paymentCategory") + 1,
      prop: "typeText",
    },
    {
      label: locale("accountPayable.paymentCategory") + 2,
      prop: "typeDetail",
    },
    {
      label: locale("accountPayable.payMoney"),
      prop: "payMoney",
    },
    {
      label: locale("accountPayable.threeTotal"),
      prop: "payAmount",
    },
    {
      label: locale("accountPayable.th.accountPayableBalance"),
      prop: "actualAmountResidual",
    }
  ];
  let typeOption = createPaymentTypeOption();

  originAlArr.map(item => {
    let obj = {
      id: item.id,
      date: moment(item.date).format("YYYY-MM-DD"),
      name: item.name,
      type: item.type,
      typeText: "",
      typeDetail: item.typeDetail,
      payMoney: item.payMoney.toLocaleString(),
      payAmount: item.payAmount.toLocaleString(),
      actualAmountResidual: item.actualAmountResidual.toLocaleString(),
    };

    for (let i = 0; i < typeOption.length; i++) {
      if (obj.type == typeOption[i].value) {
        obj.typeText = typeOption[i].label;
        break;
      }
    }

    newArr.push(obj);
  });

  return {
    tableData: newArr,
    thead: thead,
  };
};

export const packageEditPaymenTableData = (payableArr, paymentArr) => {
  let newArr = [];

  payableArr.map((item, index) => {
    let obj = JSON.parse(JSON.stringify(item));

    obj.adjustment = paymentArr[index].adjustment;
    obj.payMoney = paymentArr[index].payMoney;
    obj.offset = paymentArr[index].offset;
    obj.accountPayableBalance = paymentArr[index].actualAmountResidual;

    newArr.push(obj);
  });

  return newArr;
};

export const createTypeList = () => {
  return [
    {
      value: "TICKETING",
      label: locale("accountPayable.type.TICKETING"),
    },
    {
      value: "BUY",
      label: locale("accountPayable.type.BUY"),
    },
    {
      value: "ELSE_BUY",
      label: locale("accountPayable.type.ELSE_BUY"),
    },
    {
      value: "PROXY_BUY",
      label: locale("accountPayable.type.PROXY_BUY"),
    }
  ];
};

export const formatOneTimePaymentTableData = (originAlArr, typeList) => {
  let newArr = [];
  let typeArr = [];
  let lastTr = {
    paymentDueDate: locale("accountPayable.trTotal"),
    needPayAmount: 0,
    payAmount: 0,
    accountPayableBalance: 0,

    adjustment: 0,
    offset: 0,
    payMoney: 0,
  };

  for (let i = 0; i < typeList.length; i++) {
    typeArr.push(typeList[i].value);
    typeArr.push(typeList[i].label);
  }

  originAlArr.map(item => {
    let obj = {
      id: item.id,
      type: item.type,
      name: item.name,
      requestDeadDate: item.requestDeadDate ? moment(item.requestDeadDate).format("YYYY-MM-DD") : item.requestDeadDate,
      paymentDueDate: item.payDate ? moment(item.payDate).format("YYYY-MM-DD") : item.payDate,
      needPayAmount: item.needPayAmount.toLocaleString(),
      payAmount: item.payAmount.toLocaleString(),
      accountPayableBalance: item.actualAmountResidual.toLocaleString(),
      adjustment: 0,
      offset: 0,
      payMoney: 0,
    };
    let typeIndex = typeArr.indexOf(item.type);

    obj.typeText = typeArr[typeIndex + 1];
    lastTr.needPayAmount += item.needPayAmount;
    lastTr.payAmount += item.payAmount;
    lastTr.accountPayableBalance += item.actualAmountResidual;

    newArr.push(obj);
  });

  lastTr.needPayAmount = lastTr.needPayAmount.toLocaleString();
  lastTr.payAmount = lastTr.payAmount.toLocaleString();
  lastTr.accountPayableBalance = lastTr.accountPayableBalance.toLocaleString();
  lastTr.adjustment = lastTr.adjustment.toLocaleString();
  lastTr.offset = lastTr.offset.toLocaleString();
  lastTr.payMoney = lastTr.payMoney.toLocaleString();

  newArr.push(lastTr);

  return newArr;
};

// export const createThead = () => {
//   return [
//     {
//       label: locale("dailyClosing.th.cinemaName"),
//       prop: "cinemaName"
//     },
//     {
//       label: locale("dailyClosing.th.dayCloseDate"),
//       prop: "dayCloseDate",
//     },
//     {
//       label: locale("dailyClosing.th.dayCloseActionAccountName"),
//       prop: "dayCloseActionAccountName",
//     },
//     {
//       label: locale("dailyClosing.th.dayCloseSaveDate"),
//       prop: "dayCloseSaveDate",
//       align: "right",
//     },
//   ];
// };

export const requestDataCashDialog = (id, createReport) => {
  const accountsPaymentMapping = accountsPayableCashPayment => {
    return accountsPayableCashPayment.map(data => {
      return {
        accountsPayableAfter: data.accountPayableBalanceAfterPayment,
        actualAmountResidual: data.accountPayableBalance,
        cashDisbursementAmount: data.cashPaymentAmount,
        payDate: data.paymentDueDate,
        requestDeadDate: data.billingDeadline,
        requestDetails: data.billingDetailName,
        requestDetailsId: data.billingDetail,
        requestId: data.billingSubject,
        requestName: data.billingSubjectName
      };
    });
  };
  const accountsRecoveryMapping = accountReceivableCashCollection => {
    return accountReceivableCashCollection.map(data => {
      return  {
        actualAmountResidual: data.accountReceivableBalance,
        actualAmountResidualAfter: data.accountReceivableBalanceAfterCollection,
        cashRecoveryAmount: data.cashCollectionAmount,
        depositDate: data.plannedDepositDate,
        requestDeadDate: data.billingDeadline,
        requestDetails: data.billingDetailName,
        requestDetailsId: data.billingDetail,
        requestId: data.billingSubject,
        requestName: data.billingSubjectName
      };
    });
  };
  const otherCashPaymentMapping = otherPaymentCollection => {
    return otherPaymentCollection.map(data => {
      return {
        cashPayment: data.cashPaymentAmount,
        clientId: data.customerName,
        details: data.details,
        otherGoodsId: data.itemName,
        price: data.unitPrice,
        qty: data.qty,
        unit: data.unit
      };
    });
  };
  const otherCashRecoveryMapping = otherCashCollection => {
    return otherCashCollection.map(data => {
      return {
        cashRecovery: data.cashCollectionAmount,
        clientId: data.customerName,
        details: data.details,
        otherRevenueId: data.itemName,
        price: data.unitPrice,
        qty: data.qty,
        unit: data.unit
      };
    });
  };
  const shiftsMapping = targetRegistrationTableData => {
    return targetRegistrationTableData.map(data => {
      return data.id;
    });
  };

  // check if field selected
  const accountsPayableCashPayment = createReport.accountsPayableCashPayment.filter(data => data.billingSubject !== "" && data.billingDetail !== "");
  const accountReceivableCashCollection = createReport.accountReceivableCashCollection.filter(data => data.billingSubject !== "" && data.billingDetail !== "");
  const otherPaymentCollection = createReport.otherPaymentCollection.filter(data => data.customerName !== "" && data.itemName !== "");
  const otherCashCollection = createReport.otherCashCollection.filter(data => data.customerName !== "" && data.itemName !== "");

  return {
    id: id,
    // cinemaId: window.localStorage.getItem("cinemaId"),
    dayCloseDate: createReport.date,
    accountsPayment: accountsPayableCashPayment.length > 0 ? accountsPaymentMapping(reverseAccountsPayableCashPaymentData(accountsPayableCashPayment)) : [],
    accountsRecovery: accountReceivableCashCollection.length > 0 ? accountsRecoveryMapping(reverseAccountReceivableCashCollectionData(accountReceivableCashCollection)) : [],
    otherCashPayment: otherPaymentCollection.length > 0 ? otherCashPaymentMapping(reverseOtherCashPaymentData(otherPaymentCollection)) : [],
    otherCashRecovery: otherCashCollection.length > 0 ? otherCashRecoveryMapping(reverseOtherCashCollectionData(otherCashCollection)) : [],
    shifts: createReport.targetRegistrationTableData ? shiftsMapping(createReport.targetRegistrationTableData) : [],
    weather: createReport.weather === "" ? 0 : createReport.weather
  };
};

export const accountsRecoveryBaseStruct = () => ({
  actualAmountResidual: 0,
  actualAmountResidualAfter: 0,
  cashRecoveryAmount: 0,
  depositDate: null,
  // id: null,
  requestDeadDate: null,
  requestDetails: "",
  requestDetailsId: "",
  requestId: "",
  requestName: "",
});

export const otherCashRecoveryBaseStruct = () => ({
  cashRecovery: 0,
  clientId: "",
  details: "",
  otherRevenueId: "",
  price: 0,
  qty: 0,
  unit: "",
});

export const accountsPaymentBaseStruct = () => ({
  accountsPayableAfter: 0,
  actualAmountResidual: 0,
  cashDisbursementAmount: 0,
  // id: null,
  payDate: null,
  requestDeadDate: null,
  requestDetails: "",
  requestDetailsId: "",
  requestId: "",
  requestName: "",
});

export const otherCashPaymentBaseStruct = () => ({
  cashPayment: 0,
  clientId: "",
  details: "",
  otherGoodsId: "",
  price: 0,
  qty: 0,
  unit: "",
});

export const receivableType = () => ({
  settlement: locale("dailyClosing.accountsReceivableTable.allCashRegisterAmountsTableData.accountsReceivableType.settlement"), //決済
  nationalTicket: locale("dailyClosing.accountsReceivableTable.allCashRegisterAmountsTableData.accountsReceivableType.nationalTicket"), //全国共通券
  couponType: locale("dailyClosing.accountsReceivableTable.allCashRegisterAmountsTableData.accountsReceivableType.couponType"), //劇場引換券
  advanceTicket: locale("dailyClosing.theaterAdvanceTicketTable.allCashRegisterAmountsTableData.ticketType.advanceTicket"), //劇場前売券
});

export const salesAccountsStruct = () => ({
  amount: 0,
  clientId: "",
  details: "",
  otherRevenueId: "",
  price: 0,
  qty: 0,
  unit: "",
});

export const ticketDetailResStruct = () => ({
  actualAmount: 0,
  actualQty: 0,
  actualSales: 0,
  amount: 0,
  cashBalance: 0,
  cashQty: 0,
  dayActualQty: 0,
  details: {
    actualTotal: 0,
    advanceTicketSales: 0,
    commercial: 0,
    concession: 0,
    nationalTicketSales: 0,
    otherRevenue: 0,
    preSalesTicket: 0,
    salesTotal: 0,
    ticket: 0,
    totalAmount: 0,
    totalInsufficient: 0,
  },
  name: "",
  paymentType: "",
  price: 0,
  qty: 0,
  settlementId: "",
  dayQty: 0, // ext filed from shortageDetailResStruct
  saleQty: 0, // ext filed from shortageDetailResStruct
  dayInsufficient: 0, // ext filed from shortageDetailResStruct
  insufficientTotal: 0, // ext filed from shortageDetailResStruct
});

export const shortageDetailResStruct = () => ({
  actualSales: 0,
  cashBalance: 0,
  cashQty: 0,
  dayActualQty: 0,
  dayInsufficient: 0,
  dayQty: 0,
  insufficientTotal: 0,
  name: "",
  price: 0,
  saleQty: 0,
});
